import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'locations',
  inputShow: gql`
    query locations($input: LocationQueryInput) {
      locations(input: $input) {
        id
        name
        unit
        company_id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    label: 'Locations',
    group: 'Facilities',
    order: 2,
  },
};
